import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useFeatures } from '../context/FeatureContext';

// Gates a route behind an entitlement feature flag. Mirrors the backend
// requireFeature(...) middleware: if the tenant's plan doesn't include
// `feature`, redirect to the company root instead of rendering the page.
// While entitlements are still loading we render nothing to avoid a flash
// of the redirect.
export const FeatureRoute = ({ component: Component, feature, ...rest }) => {
  const { features, hasLoaded } = useFeatures();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!hasLoaded) return null;
        if (!features?.[feature]) {
          const companyId = props.match?.params?.companyId;
          return (
            <Redirect
              to={{
                pathname: companyId ? `/${companyId}/` : '/',
                state: { featureBlocked: feature, from: props.location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};
